export class ScopeDefinition {
    /**
     *
     */
    constructor(description: string, details: string, icon: string, name: string) {
        this.Name = name, 
        this.Description = description, 
        this.Details = details, 
        this.Icon = icon
    }
    Name = '';
    Icon = '';
    Description = '';
    Details = '';
}

function Define(description: string, details: string, icon: string, name: string) {
    var def = new ScopeDefinition(description, details, icon, name);
    return def;
}

const leads = Define("Read, edit, and add leads", "Granting this permission will allow all facets of a lead to be read and edited on your behalf.", "fas fa-user-edit", "Leads");
const broker = Define("Access data only available to brokers or team leads", "Granting this permission requires that your access level be broker or team lead", "fas fa-user-shield", "Broker");

export const ScopeDefinitions = {
    leads,
    broker
};

